module.exports = __webpack_public_path__ + "img/print-check-icon.ab57de3a.svg";